import NsContent from 'components/common/ns-content/NsContent';
import NsDownload from '@britishgasenergy/react-nucleus/dist/nuc-components/NsDownload';

import { NsCheckboxInput } from 'components/common/ns-checkbox-input/NsCheckboxInput';
import { NsInputterValidations } from 'components/common/ns-inputter/NsInputterValidations';
import { actionUrl } from 'config/static-content';
import { NsSecondaryCta } from 'components/common/ns-secondary-cta/NsSecondaryCta';
import { PARTNERS } from 'config/app-config';
import { useIsLoginEnabledJourney } from 'hooks/useIsLoginEnabledJourney';
import NsInputterEvent from 'components/common/ns-inputter/NsInputterEvent';

export const testId = 'termsAndConditionsTestId';

type TermsAndConditionsProps = {
  handleChange?: (event: NsInputterEvent) => void;
  tariffTermsPDF?: string;
  isTOU: boolean;
};

export const TermsAndConditions = ({ handleChange, tariffTermsPDF, isTOU }: TermsAndConditionsProps) => {
  const isVoiceSalesJourney = useIsLoginEnabledJourney({
    exclude: [PARTNERS.NONDOMESTIC_TRANSFER]
  });
  const isTouCheckBoxCopy = isTOU
    ? `I've read and accept the British Gas Terms & Conditions, 
  Tariff Terms & Conditions, Privacy Policy and agree to half-hourly meter 
  readings`
    : `I've read and accept the British Gas Terms & Conditions and The
  Tariff Terms & Conditions`;
  const checkboxLabel = isVoiceSalesJourney
    ? "Can I confirm you're happy to enter into a contract with British Gas?"
    : isTouCheckBoxCopy;
  const hasTermsDocs = !isVoiceSalesJourney;

  return (
    <>
      {hasTermsDocs && (
        <div>
          <h3>Important documents</h3>
          <NsContent>
            <p>
              <NsSecondaryCta href={actionUrl.bgTermsAndConditions}>
                British Gas Terms & Conditions
              </NsSecondaryCta>
            </p>
            <p>
              <NsDownload href={tariffTermsPDF}>
                This Tariff Terms & Conditions
              </NsDownload>
            </p>
            <p>
              <NsSecondaryCta href={actionUrl.privacy}>
                Privacy policy
              </NsSecondaryCta>
            </p>
          </NsContent>
        </div>
      )}
      <NsCheckboxInput
        name="terms"
        testId={testId}
        onChange={handleChange}
        options={[{ label: checkboxLabel, value: 'true' }]}
        validation={[NsInputterValidations.isRequired]}
      />
    </>
  );
};
